import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Divider,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../../../theme";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import {
  OrderInfo,
  OrderItemDTO,

  getOrderItemsByOrderId,

  orderItemInvoice,

  useOrderSlice,
} from "../../../redux/slice/order/OrderSlice";
import OptionsPopup, {
  OptionPopupObjectProps,
} from "../../common/OptionsPopup";
import Header from "../../common/Header";
import Card from "../../common/Card";
import CustomDatePicker from "../../common/CustomDatePicker";
import CustomTextField from "../../common/CustomTextField";
import Button from "../../common/Button";
import {
  Add,
  AddCircleOutlineOutlined,
  ArrowDownwardOutlined,
  Cancel,
  CheckCircleOutline,
  ConstructionOutlined,
  CurrencyExchangeOutlined,
  Delete,
  Edit,
  ModeOutlined,
  PaidOutlined,
} from "@mui/icons-material";
import CustomCheckbox from "../../common/CustomCheckBox";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { selectIsTokenAvailable } from "../../../redux/slice/authSlice";
import dayjs from "dayjs";
import { getProductItemHistory } from "../../../redux/slice/product/createProductSlice";
import { getProductItem } from "../../../service/ProductService";
import {
  getPracticeProductById,
  getPracticeProductByPracticeProductId,
  PracticeInfo,
} from "../../../redux/slice/practiceSlice";
import {
  MainErrorInfo,
  SingleAlertInfo,
  setMainErrorObj,
  setSingleAlertObj,
} from "../../../redux/slice/commonSlice";
import CustomCurrencyField from "../../common/CustomCurrencyField";
import Dropzone, { ExtendedFile } from "../../common/Dropzone";
import { calculateCommissionAmount, calculateCommissionRate, convertBase64, formatValue, fullName, getCodeTableDisplayLabel, hideElement, isV3CommissionType, priceFormatter, sortNames, toCommissionTypeRequestKey } from "../../../utils/Utility";
import {
  addInvoice,
  Attachment,
  getApplyInvDetailById,
  SaveInvoiceInfo,
  useInvoiceSlice,
} from "../../../redux/slice/invoice/InvoiceSlice";
import { COMMISSION_TYPE_CODETABLE, ORDER_AVAILABILITY, RESPONSE_CODES } from "../../../constants/applicationConstants";
import { useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import moment from "moment";
import { useNavigation } from "../../../hooks/useNavigation";
import CustomTable from "../../common/CustomTable";
import CustomIconButton from "../../common/CustomIconButton";
import AddProductCommissionModal from "../agency/ProductCommissionPopup";
import { fetchProductsByUserRoleData, ProductInfo, useProductListReducer } from "../../../redux/slice/product/productListSlice";
import { AgencyOption, CreateSearchAgency, editAgencyProductCommission, fetchActiveAgencyExecutives, fetchAssociateAgencyList, getPracticeListByUserRoleInAgency, Option, ProductCommissionAgency, useAgencyReducer } from "../../../redux/slice/agency/AgencySlice";
import OVRCommissionPopup from "../orders/OvrCommissionPopup";
import EditCommissionPopup from "../orders/EditCommissionPopup";
import { createImportSpecifier } from "typescript";
import { addClaim, addReimbursedClaim, claimInfo, ClaimInfo, orderItemClaim, reimburseClaimInfo } from "../../../redux/slice/claim/ClaimSlice";

interface Column {
  id: string;
  label: string | JSX.Element;
  minWidth?: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
}

export interface OrderItemRow {
  select: JSX.Element;
  orderItemId: number;
  serialNumber: string;
  size: string;
  mfgInvoiceNumber?: string;
  tissueTrackingId: number;
  productReturnId: number;
  productReturnStatus?: string;
  claim: ClaimInfo;
  claimId?: string;
  invoice: orderItemInvoice;
  extendedPrice: number;
  invoiceId: number;
  units: number;
  hasSKUPrice: boolean;
}

interface billingForm {
  insuranceClaim: string;
  mfgInvoice: string;
  invoiceAmt: number;
  claimSubmittedDate: any;
  invoiceDueDate: string;
  claimAmt: number;
  attachment: Attachment[];
  claimNumber: string;
}

interface FormattedOrderItem {
  orderItemId: number;
}

const RecordClaim = () => {
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      insuranceClaim: "",
      mfgInvoice: "",
      claimSubmittedDate: "",
      invoiceDueDate: "",
    },
  });

  const { navigate } = useNavigation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useAppDispatch();
  const { allCodeTablesValuesMap } = useCodetablesSlice();
  const [order, setOrder] = useState<OrderInfo>();
  const [checkedList, setCheckedList] = useState<number[]>([]);
  const [showOptionPopup, setShowOptionsPopup] =
    useState<OptionPopupObjectProps>({ message: "", show: false });
  const [orderInfo, setOrderInfo] = useState<OrderInfo>();
  const { orderItemsListInfo , editProductCommissionStatus } = useOrderSlice();
  //CS-1191 - Start
  const { applyInvDetail } = useInvoiceSlice();
  //CS-1191 - End
  const [submitAction, setSubmitAction] = useState<string>();
  const [productExtendedPrice, setProductExtendedPrice] = useState<number>(0);
  const [orderItemRow, setOrderItemRow] = useState<OrderItemRow[] | []>([]);
  const [totalExtendedPrice, setTotalExtendedPrice] = useState(0);
  const [statusCount, setStatusCount] = useState<{
    orderItemsCount: number;
    countToCheck: number;
  }>({
    orderItemsCount: 0,
    countToCheck: 0,
  });
  const location = useLocation();
  const [extendedPriceInfo, setExtendedPriceInfo] = useState("");
  const [invoiceNetdays, setInvoiceNetdays] = useState(0);
  const [invoiceDueDate, setInvoiceDueDate] = useState<string | undefined>(undefined);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showOvrCommissionPopup, setShowOvrCommissionPopup] = useState(false);
  const [showEditCommissionPopup, setShowEditCommissionPopup] = useState(false);
  const [agencyData,setAgencyData]=useState({})
  const [newOvrCommissionData, setNewOvrCommissionData] = useState<any>([]);
  const [newInvSpecificCommissionData, setNewInvSpecificCommissionData] = useState<any>([]);
  const [combinedCommissionData, setCombinedCommissionData] = useState<any[]>([]);
  const [productItems, setProductItems] = useState<any[]>([]);

  const Columns: Column[] = [
      { id: "type", label: "Type", minWidth: 100 },
      { id: "agency", label: "Agency", minWidth: 200 },
      { id: "commissionPercent", label: "Rate(%)", minWidth: 50 },
      { id: "commissionAmount", label: "Amount($)", minWidth: 50 },
      { id: "actionButtons", label: "Action", minWidth: 50 },
    ];
  const orderGraftColumns : Column[]=[
      { id: "checkBox", label: <CustomCheckbox control={control} onChange={(e) => handleSelectAllCheckbox(e)} controllerName="selectAll"/> },
      { id: "orderSize", label: "Ordered Size", minWidth: 100 },
      { id: "serialNumber", label: "Serial Number", minWidth: 100 },
      { id: "hcpcsCode", label: "HCPCS Code", minWidth: 100 },
      { id: "cogs", label: "COGs", minWidth: 100 },
      { id: "allowablePrice", label: "Allowable", minWidth: 100 },
  ]
  useEffect(() => {
    const orderDetails: OrderInfo = location?.state?.selectedOrderBilling;
    const dateOfService = orderDetails.dateOfService;
    const orderDate = orderDetails.orderDate;

    if (orderDetails) {
      const fetchProduct = async () => {
        try {
          const product = await getProductItem(orderDetails.productId);
          const customConfig = product?.data?.data?.manufactureCustomConfig;
          const invoiceDueDate =
            customConfig?.invoice_due_date &&
            customConfig?.invoice_due_date === "date_of_service"
              ? dateOfService
              : customConfig?.invoice_due_date &&
                customConfig?.invoice_due_date === "order_date"
              ? orderDate
              : "";
          const invoiceNetdays =
            customConfig?.invoice_net_days && customConfig?.invoice_net_days > 0
              ? customConfig?.invoice_net_days
              : 0;
            const prodItems = product?.data?.data?.productItems;
          setProductItems(prodItems);
          setInvoiceNetdays(invoiceNetdays);
          setInvoiceDueDate(invoiceDueDate);
        } catch (error) {
          console.error("Error fetching product:", error);
        }
      };
      fetchProduct();
      dispatch(getApplyInvDetailById({ practiceId: orderDetails.practiceId, productId: orderDetails.productId }));
    }

    setOrderInfo(orderDetails);
    dispatch(getProductItemHistory({ productId: orderDetails.productId }));
    dispatch(getOrderItemsByOrderId(orderDetails.orderId));
    dispatch(getPracticeProductById(orderDetails.productId.toString())).then(
      (res) => {
        if (res.payload) {
          const productAgreementObject = res.payload;
          setProductExtendedPrice(productAgreementObject.extendedPrice);
        }
      }
    );
  }, []);
  useEffect(() => {
    dispatch(getApplyInvDetailById({ practiceId: location?.state?.selectedOrderBilling.practiceId, productId: location?.state?.selectedOrderBilling.productId }));
  }, [editProductCommissionStatus === "success"])
  const parseSize = (size: string): number => {
    const sizeWithoutCm = size.replace("cm", "");
    const [length, width] = sizeWithoutCm.split("x").map(Number);
    return length * width;
  };

  const modifyClaimObject = (
    claim: orderItemClaim,
    size: string
  ): orderItemClaim => {
    return {
      ...claim,
      claimAmount: parseSize(size) * 122,
    };
  };

  const selectedOrderItems: { orderItemId: number }[] = useMemo(() => {
    const newSelectedOrderItems: { orderItemId: number }[] = checkedList?.map(
      (id) => ({
        orderItemId: id,
      })
    );
    return newSelectedOrderItems;
  }, [checkedList]);

  const onSubmit = async (data: any) => {
    if (submitAction === "markClaim") {
      let selectedOrderIds: number[] = []
      if(selectedOrderItems){
        selectedOrderIds = selectedOrderItems.map(item => item.orderItemId);
      }
      if (orderInfo) {
        const claimDtoObject: claimInfo = {
          orderId: orderInfo?.orderId,
          productId: orderInfo?.productId,
          claimNumber: data.claimNumber,
          claimAmount: data.claimAmt,
          claimStatus: "SUBMITTED",
          submittedDate: data.claimSubmittedDate ? dayjs(data.claimSubmittedDate).format("MM/DD/YYYY") : "",
          orderItems: selectedOrderItems,
        };
        const response = await dispatch(addClaim(claimDtoObject));

        if (response.payload && response.payload.data.message === "SUCCESS") {
          let alertMessage = "Claim Submitted!";
          const alertObj: SingleAlertInfo = {
            message: alertMessage,
            alertType: "success",
          };
          navigate('/claim_list')
          dispatch(setSingleAlertObj(alertObj));
        }
      }
    } else if (submitAction === "markInvoiced") {
      if (checkedList?.length > 0) {
        //CS-1213 - Start
        const commissionRequests = combinedCommissionData?.map((item, index) => {
          const amount = getValues(`commissionAmt-${index}`);
          return {
            agencyId: item.agencyId,
            agencyType: toCommissionTypeRequestKey(allCodeTablesValuesMap, item.agencyType),
            productCommissionId: item.productCommissionId || null,
            expectedCommissionRate: item.commissionRate !== null ? item.commissionRate : null,
            expectedCommissionAmount: amount || 0, // fallback to 0 if empty
            commissionChangeForAllFutureInvoices: item.commissionChangeForAllFutureInvoices || false,
          };
        });
        const hasMissingV3Rate = commissionRequests?.some(
          (data: any) => isV3CommissionType(allCodeTablesValuesMap, data?.agencyType) && data?.expectedCommissionRate === null
        );

        if (hasMissingV3Rate) {
          let alertMessage = `Service rate for ${getCodeTableDisplayLabel(allCodeTablesValuesMap, COMMISSION_TYPE_CODETABLE, "V3")} agency is missing. Please add a service rate to calculate service fee amount before proceeding.`;
          const alertObj: SingleAlertInfo = {
            message: alertMessage,
            alertType: "error",
          };
          return dispatch(setSingleAlertObj(alertObj));
          // prevent proceeding
        }
        //CS-1213 - End
        setShowOptionsPopup({
          message:
            data.claimAmt == data.invoiceAmt
              ? "Do you really want to record the the invoice?"
              : "Calculated Amount and Invoice Amount are not equal. Do you still want to record the invoice?",
          show: true,
          variant: "confirm",
          buttons: [
            {
              name: "Confirm",
              color: "primary",
              onClick: () => submitMarkInvoiced(data),
            },
            { name: "Cancel", color: "secondary", onClick: cancelOptionPopup },
          ],
        });
      } else {
        let alertMessage = "Please select atleast one order item";
        const alertObj: SingleAlertInfo = {
          message: alertMessage,
          alertType: "error",
        };
        dispatch(setSingleAlertObj(alertObj));
      }
    }
  };

  const submitMarkInvoiced = async (data: billingForm) => {
    if (orderInfo) {
      const product = await getProductItem(orderInfo.productId);
      const manufacturerId =
        product && product.data.data && product.data.data.manufacturerId;

      const formattedInvoiceDueDate = moment(data.invoiceDueDate, "MM/DD/YYYY", true).isValid()
        ? moment(data.invoiceDueDate).format("MM/DD/YYYY")
        : moment().format("MM/DD/YYYY");
      const commissionRequests = combinedCommissionData?.map((item, index) => {
        const amount = getValues(`commissionAmt-${index}`); 
        return {
          agencyId: item.agencyId,
          agencyType: toCommissionTypeRequestKey(allCodeTablesValuesMap, item.agencyType),
          productCommissionId: item.productCommissionId || null,
          expectedCommissionRate: item.commissionRate!== null ? item.commissionRate: null, //CS-1213
          expectedCommissionAmount: amount || 0, // fallback to 0 if empty
          commissionChangeForAllFutureInvoices: item.commissionChangeForAllFutureInvoices || false,
        };
      });
      const invoiceDtoObject: any = { //SaveInvoiceInfo
        orderId: orderInfo?.orderId,
        manufacturerId: manufacturerId,
        mfgInvoiceNumber: data.mfgInvoice,
        mfgInvoiceDate:moment(data?.claimSubmittedDate).format("MM/DD/YYYY"),
        invoiceDueDate: formattedInvoiceDueDate,
        calculatedAmount: data.claimAmt,
        invoiceAmount: Number(data.invoiceAmt),
        shippingCharges:null,
        orderItems: selectedOrderItems,
        attachInvoice: data.attachment,
        orderInvoiceStatus:
          statusCount.countToCheck === checkedList?.length
            ? "INVOICED"
            : "PARTIAL",
        commissionRequests: commissionRequests
      };
    

      if (commissionRequests?.some((data: any) => (isV3CommissionType(allCodeTablesValuesMap, data?.agencyType)||data?.agencyType === "AGENCY" || data?.agencyType === "OVERRIDE") && data?.expectedCommissionAmount <= 0)) {

        setShowOptionsPopup({
          message: `Service Fee amount for the ${getCodeTableDisplayLabel(allCodeTablesValuesMap, COMMISSION_TYPE_CODETABLE, "V3")}/Agency/Override Agency is missing or zero. Do you still want to proceed with recording the invoice?`,
          show: true,
          variant: "confirm",
          buttons: [
            {
              name: "Confirm",
              color: "primary",
              onClick: async () => {
                const response = await dispatch(
                  addInvoice({
                    invoiceData: invoiceDtoObject,
                    interceptorOption: { skipErrorPopup: true },
                  })
                );
                if (response?.payload?.code === RESPONSE_CODES.SUCCESS_CODE) {
                  let alertMessage = "Invoice was recorded successfully";
                  const alertObj: SingleAlertInfo = {
                    message: alertMessage,
                    alertType: "success",
                  };
                  dispatch(setSingleAlertObj(alertObj));
                  navigate("/invoice_list");
                } else if (response?.payload?.code === RESPONSE_CODES.FAILED_CODE) {
                  let alertMessage = response.payload?.message;
                  const alertObj: SingleAlertInfo = {
                    message: alertMessage,
                    alertType: "error",
                  };
                  dispatch(setSingleAlertObj(alertObj));
                }
                cancelOptionPopup();
              },
            },
            { name: "Cancel", color: "secondary", onClick: cancelOptionPopup },
          ],
        });
      } else {
        const response = await dispatch(
          addInvoice({
            invoiceData: invoiceDtoObject,
            interceptorOption: { skipErrorPopup: true },
          })
        );
        if (response?.payload?.code === RESPONSE_CODES.SUCCESS_CODE) {
          let alertMessage = "Invoice was recorded successfully";
          const alertObj: SingleAlertInfo = {
            message: alertMessage,
            alertType: "success",
          };
          dispatch(setSingleAlertObj(alertObj));
          navigate("/invoice_list");
        } else if (response?.payload?.code === RESPONSE_CODES.FAILED_CODE) {
          let alertMessage = response.payload?.message;
          const alertObj: SingleAlertInfo = {
            message: alertMessage,
            alertType: "error",
          };
          dispatch(setSingleAlertObj(alertObj));
        }
        cancelOptionPopup();
      }
    }
  };

  const cancelOptionPopup = () => {
    setShowOptionsPopup({ message: "", show: false });
  };

  const claimDtoObject: orderItemClaim = {
    claimId: 2,
    claimNumber: "C3156456",
    claimAmount: 22.36,
    claimStatus: "REIMBURSED",
    submittedDate: "05/22/2024",
    reimbursedDate: "06/13/2024",
  };

  useEffect(() => {
    const fetchOrderItems = async () => {
      if (orderItemsListInfo) {
        let count = 0;
        const orderItemsPromises = orderItemsListInfo.map(async (orderItem) => {
          const response = await dispatch(
            getPracticeProductByPracticeProductId({practiceProductId: orderItem.practiceProductId, productItemId: orderItem.productItemId.toString()})
          );
          const invoicedStatus = (orderItem?.tissueTrackingId && orderItem?.invoiceId) || (orderItem?.productReturnId && orderItem?.invoiceId) || (!orderItem?.tissueTrackingId && !orderItem?.productReturnId && orderItem?.invoiceId);
          if (
            !invoicedStatus
          ) {
            count += 1;
            setStatusCount((prev) => {
              return { ...prev, countToCheck: count };
            });
          }
          return {
            select: <CustomCheckbox 
              control={control} 
              name="select"
              checked={orderItem.claimId != null}
              isDisabled={orderItem.claimId ? orderItem.claimId != null : false} />,
            orderItemId: orderItem.orderItemId,
            serialNumber: orderItem.serialNumber,
            size: orderItem.size,
            mfgInvoiceNumber: orderItem.mfgInvoiceNumber,
            tissueTrackingId: orderItem.tissueTrackingId,
            productReturnId: orderItem.productReturnId,
            productReturnStatus: orderItem.productReturnStatus,
            claim: modifyClaimObject(claimDtoObject, orderItem.size),
            claimId: orderItem.claimId,
            invoice: orderItem.invoice,
            extendedPrice: response?.payload?.extendedPrice
              ? response.payload.extendedPrice
              : "",
            productItemId: orderItem.productItemId,
            invoiceId: orderItem.invoiceId,
            units: orderItem.units,
            hasSKUPrice: orderItem.hasSKUPrice,
            hcpcsCode: orderItem.hcpcsCode,
            allowableUnitPrice: orderItem.allowableUnitPrice,
          };
        });
        const orderItems = (await Promise.all(orderItemsPromises)).sort((a, b) => a.units - b.units); 

        const extendedPrices = orderItems
          .map((item) => item.extendedPrice)
          .filter((price) => price !== "");
        const firstArrayPrice = extendedPrices[0] || "";
        setExtendedPriceInfo(firstArrayPrice);

        // setOrderItemRow(orderItems);
        setStatusCount((prev) => {
          return { ...prev, orderItemsCount: orderItemsListInfo.length };
        });
      }
    };

    fetchOrderItems();
  }, [orderItemsListInfo]);

  const handleCheckboxChange = (
    e: any,
    orderItemId: number,
    extendedPrice: number,
    units: number,
    hasSKUPrice: boolean
  ) => {
    const { checked } = e.target;

    setTotalExtendedPrice((prev) => {
      const newVal = checked
        ? prev + (hasSKUPrice ? extendedPrice : extendedPrice * units)
        : prev - (hasSKUPrice ? extendedPrice : extendedPrice * units);
      setValue("claimAmt", newVal);
      return newVal;
    });

    setCheckedList((prev) => {
      if (!prev.includes(orderItemId)) {
        return [...prev, orderItemId];
      }
      return prev.filter((id) => id !== orderItemId);
    });
  };

  const handleMarkedClaimReimbursed = async (claim: orderItemClaim) => {
    const addReimbursedClaimObj: reimburseClaimInfo = {
      claimId: claim.claimId,
      claimAmount: claim.claimAmount ? claim.claimAmount : 0,
      claimStatus: "REIMBURSED",
      reimbursedDate: dayjs(new Date()).format("MM/DD/YYYY"),
    };
    const response = await dispatch(addReimbursedClaim(addReimbursedClaimObj));
  };

  const handleMarkedInvoicePaid = (orderItemId: number) => {
    // setIsInvoicePaid((prevStatuses) => ({
    //   ...prevStatuses,
    //   [orderItemId]: !prevStatuses[orderItemId],
    // }));
  };

  const orderItemStatus = useCallback((row: OrderItemRow) => {
    if (row?.tissueTrackingId) {
      if (row?.invoiceId) {
        return "Applied (Invoiced)";
      }
      return "Applied";
    } else if (row?.productReturnId) {
      if(row.productReturnStatus === ORDER_AVAILABILITY.RETURN_INITIATED){
      if (row?.invoiceId) {
        return "Return Initiated (Invoiced)";
      }
      return "Return Initiated";
    }
    if(row.productReturnStatus === ORDER_AVAILABILITY.RETURN_PENDING){
      if (row?.invoiceId) {
        return "Return Pending (Invoiced)";
      }
      return "Return Pending";
    }
    if(row.productReturnStatus === ORDER_AVAILABILITY.RETURN_REJECTED){
      if (row?.invoiceId) {
        return "Return Rejected (Invoiced)";
      }
      return `Available`;
    }
    if(row.productReturnStatus === ORDER_AVAILABILITY.RETURNED){
      if (row?.invoiceId) {
        return "Returned (Invoiced)";
      }
      return `Returned`;
    }
    } else if (row?.invoiceId) {
      return "Invoiced";
    }
    return "Available";
  }, []);

  //CS-1191 - Start
 const renderOrderItemStatus = useCallback((row: OrderItemRow): string | JSX.Element => {
  const status = orderItemStatus(row);

  const shouldShowInvoiceLink =
    ["Invoiced", "Applied (Invoiced)", "Returned (Invoiced)","Return Initiated (Invoiced)","Return Pending (Invoiced)","Return Rejected (Invoiced)"].includes(status) &&
    row?.mfgInvoiceNumber;

  if (shouldShowInvoiceLink) {
    return (
      <>
        <span>{status}</span>
        <br/>
        <Typography sx={{ display: "inline", color: "#42A5F5", cursor: "pointer" }}>
          <Link
            component="button"
            underline="hover"
            variant="body2"
            onClick={() =>
               navigate("/billing_detail", { state: { invoiceId: row.invoiceId } })
            }
            color={colors.info[300]}
          >
            ({row?.mfgInvoiceNumber})
          </Link>
        </Typography>
      </>
    );
  }

  return status;
}, [orderItemStatus, navigate]);
//CS-1191 - End

  const columns = [
    { id: "size", label: "Ordered Size" },
    { id: "serialNumber", label: "Serial Number" },
    { id: "status", label: "Status" },
    { id: "claim", label: "Claim #" },
    { id: "invoice", label: "Invoice #" },
  ];

  const rows = orderItemRow;

  const caUpdateOrderClaim = useSelector((state: RootState) =>
    selectIsTokenAvailable("caUpdateOrderClaim")(state)
);
  const caUpdateOrderInvoice = useSelector((state: RootState) =>
    selectIsTokenAvailable("caUpdateOrderInvoice")(state)
  );

  const handleCheckboxEnableDisable = (row: any) => {
    if (row.claim && caUpdateOrderClaim) {
      if (row.claim && row.claim.claimStatus) {
        return true;
      } else {
        return false;
      }
    } else if (row.invoice && caUpdateOrderInvoice) {
      if (row.invoice && row.invoice.mfgInvoiceStatus) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const disableCheckBox = (row: OrderItemRow) => {
    const status = orderItemStatus(row);
    if(row.claimId != null){
      return true
    }
    // if (status === "Invoiced" || status === "Applied (Invoiced)" || status === "Returned (Invoiced)") {
    //   return true;
    // }
    return false;
  };

  const handleDropzoneChange = async (
    uploadedFiles: ExtendedFile[],
    fieldName: any
  ) => {
    if (uploadedFiles && uploadedFiles.length > 0) {
      const base64File = String(await convertBase64(uploadedFiles[0]));
      const fileName = uploadedFiles[0].name;
      const fileExtension = fileName
        .slice(fileName.lastIndexOf(".") + 1)
        .toLowerCase();
      const base64Substring = base64File.substring(
        fileExtension === "pdf"
          ? "data:application/pdf;base64,".length
          : "data:image/png;base64,".length,
        base64File.length
      );
      const attachmentObj: Attachment[] = [
        {
          content: base64Substring,
          documentName: fileName,
          fileType: fileExtension,
          type: "INVOICE",
        },
      ];
      setValue("attachment", attachmentObj);
    }
  };

  const handleDeleteFile = () => {
    setValue("attachment", []);
  };

  const handleSelectAllCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    if (checked) {
      const selectList: number[] = [];
      let invAmt: number = 0;
      orderItemRow?.forEach((row) => {
      const status = orderItemStatus(row);
        if (
          status !== "Invoiced" && 
          status !== "Applied (Invoiced)" && 
          status !== "Returned (Invoiced)" && 
          status !== "Return Initiated (Invoiced)" &&
          status !== "Return Pending (Invoiced)" &&
          status !== "Return Rejected (Invoiced)" &&
          row.claimId == null) {
          selectList.push(row.orderItemId);
          invAmt += (row.hasSKUPrice ? row.extendedPrice : row.extendedPrice * row.units);
        }
      });
      setTotalExtendedPrice(invAmt);
      setValue("claimAmt", invAmt);
      setCheckedList(selectList);
    } else {
      setCheckedList([]);
      setTotalExtendedPrice(0);
      setValue("claimAmt", 0);
    }
  };

  const handleDatechange = (date: any) => {
    if (date) {
      setValue(
        "invoiceDueDate",
        dayjs(date)
          .add(invoiceNetdays, "day")
          .format("MM/DD/YYYY")
      );
    }
  };
//CS-1191-START

  //CS-1191 - START
  const handleEditCommissionData = (data: any) => {
    if (watch('invoiceAmt') > 0) {
      setShowEditCommissionPopup(true)
      setAgencyData({...data, invoiceAmt: getValues('invoiceAmt')});
    } else {
      let alertMessage = "Please enter invoice amount before editing service fee data.";
      const alertObj: SingleAlertInfo = {
        message: alertMessage,
        alertType: "error",
      };
      dispatch(setSingleAlertObj(alertObj));
    }
  }
  const handleOvrCommissionPopup = () => {
    if (watch('invoiceAmt') > 0) {
      setShowOvrCommissionPopup(true);
    } else {
      let alertMessage = "Please enter invoice amount before adding new ovr service fee data.";
      const alertObj: SingleAlertInfo = {
        message: alertMessage,
        alertType: "error",
      };
      dispatch(setSingleAlertObj(alertObj));
    }
  }

  //CS-1191 - END
 const commissionActionButtons = (
    row: any,index:any
  ): JSX.Element => {
    return (
      <>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          tooltipMessage="Edit"
          tooltipPlacement="top"
          onClick={() => handleEditCommissionData(row)}//handleActionEdit(row, index)
          style={{
            display: hideElement(row?.productCommissionId ? false : true),
          }}
        >
          <Edit fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="error"
          size="small"
          variant="outlined"
          tooltipMessage="Delete"
          tooltipPlacement="top"
          onClick={() => {
            setCombinedCommissionData(prevData =>
              prevData.filter(item => item.agencyId !== row.agencyId)
            );
            setNewOvrCommissionData((prevData:any) =>
              prevData.filter((item:any) => item.agencyId !== row.agencyId)
            );
          }}
          style={{
            display: hideElement(row?.productCommissionId === null && row?.agencyType ==="OVERRIDE" ? false : true),
          }}
        >
          <Delete fontSize="small" />
        </CustomIconButton>
        {row?.agencyType !== "OVERRIDE" && (
        <CustomIconButton
          color="success"
          size="small"
          variant="outlined"
          tooltipMessage="Add"
          tooltipPlacement="top"
          onClick={() => {navigate("/agency_form", { state: { agency: { agencyId: row.agencyId } } })}}
          style={{
            display: hideElement(row?.productCommissionId !== null),
          }}
        >
          <Add fontSize="small" />
        </CustomIconButton>
        )}
      </>
    );
  };

//CS-1191 - START
useEffect(() => {
   const apiData = applyInvDetail?.commissionDetail ?? [];

  const newEntries = Array.isArray(newOvrCommissionData) ? newOvrCommissionData : [];
  const specificUpdates = Array.isArray(newInvSpecificCommissionData) ? newInvSpecificCommissionData : [];

  // Filter out any items that do not have a valid productCommissionId
  const validUpdates = [...specificUpdates].filter(item => item.productCommissionId != null);

  const updatesById = validUpdates.reduce((acc, item) => {
    acc[item.productCommissionId] = item;
    return acc;
  }, {} as Record<string | number, any>);

  // Replace specific items, only if there's a valid update
  const merged = apiData.map(item =>
    item.productCommissionId != null && updatesById[item.productCommissionId]
      ? updatesById[item.productCommissionId]
      : item
  );

  // Add new entries (OVR + Specific) which are not in the original data
  const newOnly = [...newEntries, ...specificUpdates].filter(
    item =>
      !item.productCommissionId ||
      !apiData.some(orig => orig.productCommissionId === item.productCommissionId)
  );

  setCombinedCommissionData([...merged, ...newOnly]);
}, [applyInvDetail, newOvrCommissionData, newInvSpecificCommissionData]);
// useEffect(() => {
//   const apiData = applyInvDetail?.commissionDetail ?? [];
//   const newEntries = Array.isArray(newOvrCommissionData) ? newOvrCommissionData : [];
//   const specificUpdates = Array.isArray(newInvSpecificCommissionData) ? newInvSpecificCommissionData : [];

//   // Combine updates into one reference list
//   const updatesById = [...newEntries, ...specificUpdates].reduce((acc, item) => {
//     acc[item.productCommissionId] = item;
//     return acc;
//   }, {} as Record<string, any>);

//   // Replace or keep original
//   const merged = apiData.map(item =>
//     updatesById[item.productCommissionId] ? updatesById[item.productCommissionId] : item
//   );

//   // Add any new items not already in the original apiData
//   const newOnly = [...newEntries, ...specificUpdates].filter(
//     item => !apiData.some(orig => orig.productCommissionId === item.productCommissionId)
//   );

//   // Final combined list
//   setCombinedCommissionData([...merged, ...newOnly]);

// }, [applyInvDetail, newOvrCommissionData, newInvSpecificCommissionData]);
//CS-1191 - END
  const commissionSummaryRows: any[] = useMemo(() => {
    const rows: any[] = []
    combinedCommissionData.forEach((item: any, index: any) => {
      //CS-1213 - Start
      const commAMount = calculateCommissionAmount(Number(getValues('invoiceAmt')), Number(item.commissionRate));
      const row = {
        id: item.productCommissionId,
        type: getCodeTableDisplayLabel(allCodeTablesValuesMap, COMMISSION_TYPE_CODETABLE, item.agencyType),
        agency: item.productCommissionId && item.agencyType === "OVERRIDE" ? `${item.agencyName} (${item.associateType})` : item.agencyName,
        commissionPercent: item?.commissionRate !== null ? `${formatValue(Number(item.commissionRate), { suffix: '%' })}` : '-',
        commissionAmount: (
          <span style={{ cursor: 'pointer' }} title={commAMount.toString()}>
            {formatValue(commAMount, { prefix: '$' })}
          </span>
        ),
        actionButtons: commissionActionButtons(item, index),
      };
      //CS-1213 - End
      setValue(`commissionAmt-${index}`, item?.commissionAmt || calculateCommissionAmount(getValues('invoiceAmt'), Number(item.commissionRate)))
      rows.push(row);
    });
    return rows;
  }, [combinedCommissionData, watch('invoiceAmt'), allCodeTablesValuesMap]);

  const orderGraftRows: any[] = useMemo(() => {
    const rows: any[] = []
    orderItemRow.map((item: any ,index:any) => {
      const row = {
        checkBox: <CustomCheckbox
          onChange={(e) =>
            handleCheckboxChange(
              e,
              item.orderItemId,
              item.extendedPrice,
              item.units,
              item.hasSKUPrice
            )
          }
          control={control}
          name={`select-${item.orderItemId}`}
          checked={checkedList.includes(item.orderItemId) || item.claimId}
          isDisabled={item.claimId}
        />,
        orderSize: item.size,
        serialNumber: item.serialNumber,
        status: renderOrderItemStatus(item),//orderItemStatus(item),//CS-1191 
        cogs:priceFormatter(item.hasSKUPrice ? item.extendedPrice :  item.extendedPrice * item.units),
        allowablePrice: item.allowableUnitPrice ? priceFormatter(item.allowableUnitPrice * item.units) : null,
      };
      rows.push(row);
    });
    return rows;
  }, [orderItemRow,checkedList]);

   const handleClose = () => {
    setShowOvrCommissionPopup(false);
    setShowEditCommissionPopup(false);
    setAgencyData({})
  };

  //CS-1191-END
  return (
    <>
      {showOvrCommissionPopup && (
        <OVRCommissionPopup
          open={showOvrCommissionPopup}
          handleClose={handleClose}
          onAddOvrCommission={(commission) => {
            setNewOvrCommissionData((prevCommission: any) => [...prevCommission, commission]);
          }}
          agencyData={combinedCommissionData}
        />
      )}
      {showEditCommissionPopup && (
        <EditCommissionPopup
          open={showEditCommissionPopup}
          handleClose={handleClose}
          onAddInvSpecificCommission={(commission) => {
            setNewInvSpecificCommissionData((prevCommission: any) => [...prevCommission, commission]);
          }}
          agencyData={agencyData}
        />
      )}
    <Box sx={{
          margin: {
            xs: "20px 10px", 
            sm: "20px",
          },
        }}>
      {showOptionPopup.show && (
        <OptionsPopup
          open={showOptionPopup.show}
          onClose={() => setShowOptionsPopup({ message: "", show: false })}
          variant={showOptionPopup.variant}
          message={<>{showOptionPopup.message}</>}
          buttons={showOptionPopup.buttons}
          title={showOptionPopup.title}
          obj={showOptionPopup.obj}
        />
      )}
      <Header title="Record Claim" />
      <Box>
        <Card>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box >
              <Grid container spacing={2} mb={2} >
                <Grid item md={6}>
                  <Typography component="label" fontWeight="bold" >
                    Patient : 
                  </Typography>
                  <Typography component="span"  variant="body1" style={{ paddingLeft: "10px" }}>
                    {orderInfo?.patientName}
                  </Typography>
                </Grid>
                <Grid item md={6}>
                  <Typography component="label" fontWeight="bold">
                    Product : 
                  </Typography>
                  <Typography component="span" variant="body1" sx={{ paddingLeft: "10px" }}>
                    {`${orderInfo?.productName} (${orderInfo?.manufacturerName})`}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} mb={2}>
                <Grid item md={6}>
                  <Typography component="label" fontWeight="bold">
                    {/* cs-1141 - start */}
                    Order ID : 
                    {/* cs-1141 - end */}
                  </Typography>
                  <Typography component="span" variant="body1" sx={{ paddingLeft: "10px" }}>
                    {orderInfo?.orderNumber}
                  </Typography>
                </Grid>
              </Grid>
                <Divider sx={{ padding: 0, margin: 0, mt: 1, mb: 1 }} />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6}>
                    <Card sx={{ padding: 0 }}>
                        <Box display="flex" justifyContent="space-between" sx={{ p: 2 }}mb={1}>
                        <Typography
                          variant="h5"
                          fontWeight="bold"
                          sx={{ color: colors.success[300] }}
                        >
                          Grafts
                        </Typography>
                      </Box>
                      <Box  sx={{ padding: "0px 10px 10px 10px" }}>
                        <CustomTable
                          columns={orderGraftColumns}
                          rows={orderGraftRows}
                          disablePagination={true}
                          borderBox={true}
                          showMenu={true}
                          uniqueValue="Billing"
                        />
                      </Box>
                    </Card>
                  </Grid>
                </Grid>

              <Divider sx={{ padding: 0, margin: 0, mt: 1, mb: 3 }} />
              
                <Grid container spacing={2} mb={2}>
                  <Grid item md={2} xs={12} >
                    <CustomTextField
                      label="Claim ID"
                      controllerName="claimNumber"
                      control={control}
                      rules={{required: "Claim ID is required"}}
                      // isDisabled
                    />
                  </Grid>
                  <Grid item md={2} xs={12} >
                    <CustomCurrencyField
                      label="Calculated Amt"
                      controllerName="claimAmt"
                      control={control}
                      // isDisabled
                    />
                  </Grid>
                     <Grid item xs={12} md={2}>
                  <CustomDatePicker
                    controllerName="claimSubmittedDate"
                    control={control}
                    label="Claim Submitted Date"
                    onChange={handleDatechange}
                    rules={{required: "Submitetd Date is required"}}
                  />
                </Grid>
                </Grid>
              <Grid container spacing={2} display="flex" justifyContent="end">
                <Grid item md={"auto"} xs={12}>
                  <Button
                    size="large"
                    startIcon={<CheckCircleOutline />}
                    sx={{ width: { xs: "100%", md: "auto" } }}
                    type="submit"
                    onClick={() => {
                      setSubmitAction("markClaim");
                    }}
                  >
                    Record Calim
                  </Button>
                </Grid>
                <Grid item md={"auto"} xs={12}>
                  <Button
                    color="error"
                    sx={{ width: { xs: "100%", md: "auto" } }}
                    startIcon={<Cancel />}
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </form>
        </Card>
      </Box>
    </Box>
    </>
  );
};

export default RecordClaim;
